
export class CIIArrayData{
    
    public year : string = ""
    public value : number = 0
    public letter : string = ""
    public color : string = ""
}


export class ETSArrayData{

    public year : string = ""
    public anualEmissions : number = 0
    public emissionRights : number = 0
    public costEUA : number = 0
}

export class ETSExtraData{

    public priceEUA : number = 0
    public selectedGWPOPtion : string = ""
}

export class FuelEUArrayData{

    public year : string = ""
    public fuelEUPenalty : number = 0 
    public complianceBalance : number = 0
}

export class FuelEUExtraData{

    public GWPOPtion : string = ""
    public motorLNGOPtion : string = ""
}

export class EcoefficiencyData{

    public year : number = 0
    public indexCII : number = 0
    public indexFuelEU : number = 0
    public indexETS : number = 0
}


